<section class="main-banner-area main-banner-area-one">
    <app-expansion></app-expansion>
    <div class="sm-spacer"></div>
</section>
